import styled from "styled-components";
export const CrmMarkerStyle = styled.div`
  .row {
    margin: 0px;
    .col-xl-4 {
      @media (max-width: 768px) {
        padding: 0px !important;
        p {
          font-size: 14px;
        }
      }
    }
  }
  .FilterBar {
    background: ${({ theme }) => theme.box};
    padding: 10px !important;
    margin-top: 20px;
    border-radius: 10px;
    margin-left: 12px;
    margin-right: 12px;
  }
  @media (max-width: 768px) {
    .FilterBar {
      margin-right: 0px !important;
      margin-left: 0px !important;
      padding-right: 5px !important;
      padding-left: 5px !important;
    }
  }
`;

export const Span = styled.span`
  font-size: 22px;
  color: ${(props) => props.sndColor};
  margin-left: 5px;
  letter-spacing: 1.5px;
  font-weight: bold;
`;

export const CenterBorder = styled.div`
  height: 1px;
  background-color: #e5e5e5;
  margin: 5px 0px;
`;

export const MarkerCardStyle = styled.div`
  background-color: ${({ theme }) => theme.box};
  transition: all 0.3s;
  border: 2px solid #d7d7d7;
  border-radius: 10px;
  box-shadow: 0px 1px 10px #00000010;
  padding: 15px;
  .content {
    transition: all 0.3s;
    overflow: ${(props) => props.overflow};
    height: ${(props) => props.height};
  }
  .card-data {
    color: #808080;
    line-height: 40px;
  }

  margin-top: 20px;
`;
